import { render, staticRenderFns } from "./robotset.vue?vue&type=template&id=1c07849e&scoped=true&"
import script from "./robotset.vue?vue&type=script&lang=js&"
export * from "./robotset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c07849e",
  null
  
)

export default component.exports